import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealsBoardApi, dealsBoardQueryKeys } from '@crm/entities/deals-board';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

export const useDeleteColumnMutation = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: dealsBoardApi.deleteColumn,
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: dealsBoardQueryKeys.board() });
            toastManager.onSuccess({
                title: t('crm.deals.board.column.deleteSuccess'),
            });
        },
        onError: (error) => {
            toastManager.onError({
                title: getApiErrorMessage(error, t('crm.deals.board.column.deleteError')),
            });
        },
    });
};
